import { render, staticRenderFns } from "./whitelistCompaniesComponent.vue?vue&type=template&id=a70da27a&"
import script from "./whitelistCompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./whitelistCompaniesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports